import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { PermissionService } from '../services/permission.service';
import { Permission } from '../permissions';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate, CanActivateChild {
  constructor(
    private authService: AuthService,
    private permissionService: PermissionService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.checkAccess(route, state);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.checkAccess(childRoute, state);
  }

  private checkAccess(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (!this.authService.isAuthenticated()) {
      return this.router.createUrlTree(['/login']);
    }

    const routePermission = route.data['permission'] as Permission | undefined;
    const urlPermission = this.permissionService.getPermissionForUrl(state.url);

    if (routePermission && !this.permissionService.hasPermission(routePermission)) {
      return this.router.createUrlTree([this.permissionService.getDefaultRoute()]);
    }

    if (urlPermission && !this.permissionService.hasPermission(urlPermission)) {
      return this.router.createUrlTree([this.permissionService.getDefaultRoute()]);
    }

    return true;
  }
}
